import API from '@/api';
import moment from 'moment';
const Note = API.get('Note');

export default ({
  namespaced: true,
  state: {
    id: null,
    user: JSON.parse(localStorage.getItem('user')),
    title: '',
    note: '',
    notes: [],
    active: null,
    activeIndex: null,
    removed_items: []
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    title: state => state.title,
    note: state => state.note,
    notes: state => state.notes,
    active: state => state.active,
    activeIndex: state => state.activeIndex,
    removed_items: state => state.removed_items
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {
    updateTitle(state, title) {
      state.title = title
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    updateNote(state, note) {
      state.note = note
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    add(state) {
      let user = JSON.parse(localStorage.getItem('user'))
      let author = ''
      let doctor = user?.doctor

      if (doctor) {
        if (doctor.fullname) {
          author = doctor.fullname
        } else {
          author = doctor.first_name || doctor.last_name
            ? `${doctor.first_name} ${doctor.last_name}`
            : doctor.email
        }
      }

      let note = {
        id: null,
        title: state.title,
        note: state.note,
        author: author,
        date: moment().format('MMM. D, YYYY, h:mmA'),
        doctor_id: user.id
      }

      state.notes.push(note)
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    clear(state) {
      state.id = null
      state.title = ''
      state.note = ''
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    edit(state) {
      var author = ''
      var doctor = state.user.doctor
      if (doctor !== null) {
        if (Object.prototype.hasOwnProperty.call(doctor, 'fullname')) {
          author = doctor.fullname
        } else {
          if (doctor.first_name || doctor.last_name) {
            author = `${doctor.first_name} ${doctor.last_name}`;
          } else {
            author = doctor.email
          }
        }
      }

      var note = {
        id: state.id,
        title: state.title,
        note: state.note,
        author: author,
        date: moment().format('MMM. D, YYYY, h:mmA')
      }
      state.notes.splice(state.activeIndex, 1, note);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setActive(state, index) {
      var note = state.notes[index];
      state.id = note.id,
      state.title = note.title
      state.note = note.note
      state.activeIndex = index;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    remove(state) {
      var index = state.activeIndex
      var item = state.notes[index]
      if (item.id !== null)
        state.removed_items.push(item)
      state.notes.splice(index, 1);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    loadSavedData(state, notes) {
      
      console.log({ notes }, "note.js")
      notes.forEach(async note => {
        
        let author = ''
        console.log({ note }, "note.js")

        if (note.doctor) {
          let doctor = note.doctor.doctor

          if (doctor !== null) {
            if (Object.prototype.hasOwnProperty.call(doctor, 'fullname')) {
              author = doctor.fullname
            } else {
              if (doctor.first_name || doctor.last_name) {
                author = `${doctor.first_name} ${doctor.last_name}`;
              } else {
                author = doctor.email
              }
            }
          }
        } else {
          author = 'N⁄A'
        }
        
        const data = {
          id: note.id,
          title: note.title,
          note: note.note,
          author: author,
          date: moment(note.created_at).format('MMM. D, YYYY, h:mmA'),
        }
        state.notes.push(data);
      });
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    clearStoreData(state) {
      state.id = null;
      state.title = '';
      state.note = '';
      state.notes = [];
      state.active = null;
      state.activeIndex = null;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setNoteId(state, {index, id}) {
      state.notes[index].id = id
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async save({ commit, getters }, {case_id, consult_id}) {
      getters.notes.forEach(async (note, key) => {
        const payload = {
          title: note.title,
          note: note.note
        }

        let response;
        if (note.id == null) {
          payload.patient_case_id = case_id
          payload.case_consultation_id = consult_id
          payload.doctor_id = note.doctor_id
          let response = await Note.create(payload);
          console.log("[note/save]", response, payload, key, response.data.id);
          // fix to avoid duplicate saved data on second save
          commit('setNoteId', { index: key, id: response.data.id })
        }
        else {
          response = await Note.update(note.id, payload);
          console.log("[note/update]", response, note.title, note.id);
        }
      });

      // delete removed items
      if (getters.removed_items.length) {
        getters.removed_items.forEach(async note => {
          let response = await Note.delete(note.id);
          console.log("[note/delete_removed_items]", response);
        });
      }
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async compiled_notes({ commit, getters }, {case_id, consult_id}) {
      
      getters.notes.forEach(async (note, key) => {
        const payload = {
          title: note.title,
          note: note.note
        }

        let response;
        if (note.id == null) {
          payload.patient_case_id = case_id
          payload.case_consultation_id = consult_id
          payload.doctor_id = note.doctor_id
          let response = await Note.create(payload);
          console.log("[note/save]", response, payload, key, response.data.id);
          // fix to avoid duplicate saved data on second save
          commit('setNoteId', { index: key, id: response.data.id })
        }
        else {
          response = await Note.update(note.id, payload);
          console.log("[note/update]", response, note.title, note.id);
        }
      });

      // delete removed items
      if (getters.removed_items.length) {
        getters.removed_items.forEach(async note => {
          let response = await Note.delete(note.id);
          console.log("[note/delete_removed_items]", response);
        });
      }
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async delete(state, notes) {
      if (notes) {
        notes.forEach(async note => {
          let response = await Note.delete(note.id);
          console.log("[note/delete]", response);
        });
      }
    },
  }
})